/* TRU47 — Routine Picks add-to-cart
   Northeast Control · July 2026

   Posts to /cart/add.js rather than submitting a form, because these cards render
   inside the cart drawer and cart page, which are already inside a <form>.
   Nested forms are invalid HTML and break cart quantity updates.

   Default behaviour after a successful add is a page reload — correct on every
   theme, at the cost of the drawer closing. If the theme exposes an AJAX cart,
   wire it up in refreshCart() below and delete the reload; the one-line change
   is called out in README_INSTALL.md.

   Event-delegated and idempotent, so it survives the section being re-rendered
   by the Section Rendering API. */

(function () {
  'use strict';

  if (window.__tru47RoutineBound) return;
  window.__tru47RoutineBound = true;

  function status(root, message) {
    var el = root && root.querySelector('[data-tru47-status]');
    if (el) el.textContent = message || '';
  }

  function refreshCart() {
    /* Replace this with the theme's own cart refresh if there is one, e.g.
       Dawn:  document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
       then remove the reload. Reload is the safe default. */
    window.location.reload();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-tru47-add]');
    if (!button) return;

    event.preventDefault();
    if (button.hasAttribute('aria-busy')) return;

    var root = button.closest('[data-tru47-routine]');
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    var original = button.textContent;
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    button.textContent = 'Adding…';
    status(root, '');

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root + 'cart/add.js'
            : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) return response.json().then(function (body) { throw body; });
        return response.json();
      })
      .then(function () {
        button.textContent = 'Added';
        status(root, (button.getAttribute('data-product-title') || 'Item') + ' added to your cart.');
        /* let the aria-live region announce before the page goes away */
        window.setTimeout(refreshCart, 800);
      })
      .catch(function (error) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = original;
        var message = (error && (error.description || error.message)) || 'Could not add that item.';
        status(root, message);
      });
  });
})();
